import { createIdentifyUser } from 'packages/wiretap'

import { getAuthToken } from 'app/fieldapp/store/auth/selectors'

import { ApplicationState } from '../store/store'

const identifyUser = createIdentifyUser<ApplicationState>(getAuthToken)

export const faTrackers = [identifyUser]
